import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SparklesIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="py-14 px-6 lg:px-8 bg-tea-cream relative overflow-hidden" data-id="element-332">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-333">
        <FadeIn data-id="element-334">
          <SparklesIcon className="w-12 h-12 text-tea-gold mx-auto mb-8" data-id="element-335" />
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-tea-green mb-8 leading-tight" data-id="element-336">
            En 7 días, habrás pasado de la teoría a tener muestras físicas de
            tés que cambian de color (Matcha Azul) y flores que danzan en la
            taza (Blooming Tea).
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-337">
          <p className="text-xl text-tea-charcoal/80 font-body leading-relaxed max-w-3xl mx-auto" data-id="element-338">
            No solo tendrás un producto, tendrás{' '}
            <strong className="text-tea-green font-semibold" data-id="element-339">
              contenido viral listo
            </strong>{' '}
            para que el algoritmo trabaje por ti mientras duermes.
          </p>
        </FadeIn>
      </div>
    </section>;
}